import angular from 'angular';
import angularMessages from 'angular-messages';
import angularSanitize from 'angular-sanitize';
import angularValidationMatch from 'angular-validation-match';
import ngRedux from 'ng-redux';
import ngReduxUiRouter from 'redux-ui-router';

import 'angular-file-upload';
import 'ng-focus-if';

// App styles
import './styles/app.scss';

// Application
import { Containers } from './containers';
import { Components } from './components';
import { Filters } from './filters';
import { Providers } from './providers';

// Utilities
import {
  authCheck,
  facebookInit,
  proxyCookie,
  raven,
  clearModal,
  transitionAnchorScroll,
  virtualPageview,
} from './utils';

// TODO: 
// ng-select-all-on-focus library has been unpublished from yarn directory. 
// 'ng-select-all-on-focus': AngularJS directive for selecting all text in an HTML text input when focussed.
// remove all rb-select-all-on-focus refs from html
// remove rb.select-all-on-focus from angular modules

// Modules
const modules = [
  ngRedux,
  ngReduxUiRouter,
  angularMessages,
  angularSanitize,
  angularValidationMatch,
  'angularFileUpload',
  'focus-if',
  'rb.select-all-on-focus',
  Containers,
  Components,
  Filters,
  Providers,
];

// Main App
export default angular
  .module('App', modules)
  .run(facebookInit)
  .run(authCheck)
  .run(proxyCookie)
  .run(virtualPageview)
  .run(clearModal)
  .run(transitionAnchorScroll);



// WEBPACK FOOTER //
// ./src/index.js